import React from 'react'

export default (props: any) => (
  <svg {...props} width="67" height="51" viewBox="0 0 67 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_9_136)">
      <path d="M22.0866 -2.94495e-06L22.037 49.824L43.966 49.8458L44.0156 0.0218128L22.0866 -2.94495e-06Z" fill="white" />
      <path d="M44.0206 0.0150117L43.971 49.839L66.035 49.8609L66.0846 0.0369618L44.0206 0.0150117Z" fill="#D80027" />
      <path d="M0.0495668 0.238034L0 50.062L21.929 50.0838L21.9786 0.25985L0.0495668 0.238034Z" fill="#6DA544" />
      <path d="M65.584 0.5H0.584015V50.5H65.584V0.5Z" stroke="#9F9D9D" />
    </g>
    <defs>
      <clipPath id="clip0_9_136">
        <rect width="66.084" height="51" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
